import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { FC, useEffect, useRef } from 'react';
import { AwardsItem } from '@/components/Awards/interface';
import cn from '@/helpers/cn';
import { gsap } from '@/lib/gsap';
import { AwardType } from '@/types/awards';
import css from './style.module.scss';
const itemsSort = [AwardType.Awwwards, AwardType.FWA, AwardType.CSSDesignAwards, AwardType.Orpetron, AwardType.WorldBrandDesignAwards, AwardType.ClutchAwards];
interface Props {
  items: AwardsItem[];
}
const AwardsTable: FC<Props> = t0 => {
  const $ = _c(10);
  const {
    items
  } = t0;
  const {
    push
  } = useRouter();
  const tableRef = useRef(null);
  const sortedGroups = [...items].sort(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!tableRef.current) {
        return;
      }
      const rows = tableRef.current.querySelectorAll(`.${css.awardItem}`);
      gsap.set(rows, {
        autoAlpha: 0,
        y: 20
      });
      gsap.to(rows, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.05,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: tableRef.current,
          start: "top 60%",
          once: true
        }
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items) {
    t2 = [items];
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== push) {
    t3 = caseUrl => {
      const url = caseUrl?.trim();
      if (url) {
        push(url);
      }
    };
    $[3] = push;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClick = t3;
  const t4 = css;
  let t5;
  if ($[5] !== handleClick) {
    t5 = group => <li key={group.id} className={css.groupItem}><h4 className={css.groupTitle}>{group.amount} {group.type}</h4><ul className={css.awardsList}>{group.awardsList.map(award => <li key={award.id} className={cn(css.awardItem, award.caseUrl ? css.hasLink : "")} onClick={() => handleClick(award.caseUrl)}><p className={css.name}>{award.name}</p><p className={css.additionalText}>{award.additionalText}</p>{award.caseUrl ? <p className={css.seeCaseLabel}>See Case</p> : null}<p className={css.date}>{award.detailedDate || award.date}</p></li>)}</ul></li>;
    $[5] = handleClick;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = sortedGroups.map(t5);
  let t7;
  if ($[7] !== t4.awardsTable || $[8] !== t6) {
    t7 = <ul ref={tableRef} className={t4.awardsTable}>{t6}</ul>;
    $[7] = t4.awardsTable;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default AwardsTable;
function _temp(x, y) {
  return itemsSort.indexOf(x.type) - itemsSort.indexOf(y.type);
}